{
  "name": "production",
  "hostname": "serveport.com",
  "development": false,
  "production": true,
  "applicationName": "ServePort",
  "sourceVersion": "3560c4b1fed5e26fa9bfeafd0ee7bae5faa1a256",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.serveport.com/_api/comanage/",
    "apiRootLpms": "https://@.serveport.com/_api/lpms/",
    "apiRootSquirrel": "https://@.serveport.com/_api/squirrel/",
    "apiRootRms": "https://@.serveport.com/_api/rms/"
  },
  "stripe": {
    "key": "pk_live_Js6GjAAEvwtOZ3ZNvGe149jU00TGO4Jqgw"
  },
  "auth0": {
    "authorityRoot": "auth.safarilaw.com",
    "clientId": "cPuIsG207eQuD6RWEFZmHQqbjPnPjIRk",
    "useLocalStorageCache": false
  },
  "auth": {
    "inactivityTimeout": 0,
    "inactivityWarning": 0
  },
  "statusApp": {
    "apiRootUrl": "https://@.serveport.com/_api/maintenance/",
    "code": "IldIjcjp1bhvMua1TOMwNdt1v7FZl3C04LmnVpQWj2pdAzFuobNqfA==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": false,
    "devTools": false,
    "devExceptions": false
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "3866225d-479d-4694-ba82-471c763c47d1"
    },
    "appInsights": {
      "instrumentationKey": "6d15b261-ac17-4b93-b93a-afd6fded4add"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self",
      "tusUploadLimitInMb": 0
    },
    "reports": {
      "key": "Z7V2-XIA84H-5B4B5R-0U483J-2E5P0D-6E2L5X-3M284X-0Z0W1X-531H21-6W2X0F"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "rms",
        "name": "submissions",
        "url": "signalr/submissions"
      }
    ]
  }
}
